
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import { Book } from './types';
import StatisticsCompanyAndUserTypeSchool from './StatisticsCompanyAndUserTypeSchool.vue';
import Accordion from '@/components/ui/accordion/Accordion.vue';

@Component({
  components: { Accordion, StatisticsCompanyAndUserTypeSchool }
})
export default class StatisticsCompanyAndUserTypeBook extends Vue {
  @Prop({ type: Object as PropType<Book>, default: () => {} })
  book!: Book;

  accordionExpanded: boolean = false;

  get template(): string {
    return this.$attrs.template;
  }

  get labels(): string {
    return this.$attrs.template.labels;
  }

  renderContent() {
    this.accordionExpanded = !this.accordionExpanded;
  }
}
